import ActionColumnComponent from "../../../disaster/components/ActionColumn/ActionColumn";

export const getAllColumns = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({
    viewModal,
    updateModal,
    deleteRecord,
  });

  return {
    "Attorney": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
    "Mediator": [
        {
          title: "Name",
          dataIndex: "Name",
          key: "name",
          render: (record) => (record ? record : "N/A"),
        },
        actionColumn,
      ],
      "Financial Advisor": [
        {
          title: "Name",
          dataIndex: "Name",
          key: "name",
          render: (record) => (record ? record : "N/A"),
        },
        actionColumn,
      ],
      "Accountant": [
        {
          title: "Name",
          dataIndex: "Name",
          key: "name",
          render: (record) => (record ? record : "N/A"),
        },
        actionColumn,
      ],
      "Real Estate Agent": [
        {
          title: "Name",
          dataIndex: "Name",
          key: "name",
          render: (record) => (record ? record : "N/A"),
        },
        actionColumn,
      ],
      "Insurance Agent": [
        {
          title: "Name",
          dataIndex: "Name",
          key: "name",
          render: (record) => (record ? record : "N/A"),
        },
        actionColumn,
      ],
      "Therapist": [
        {
          title: "Name",
          dataIndex: "Name",
          key: "name",
          render: (record) => (record ? record : "N/A"),
        },
        actionColumn,
      ],
      "Child Specialist": [
        {
          title: "Name",
          dataIndex: "Name",
          key: "name",
          render: (record) => (record ? record : "N/A"),
        },
        actionColumn,
      ],
 
   
  };
};
